interface RecentSearchesProps {
    items: string[];
    onSelect: (term: string) => void;
}

export const RecentSearches = ({ items, onSelect }: RecentSearchesProps) => {
    if (items.length === 0) return null;
    return (
        <div data-testid="recent-searches" className="px-4 py-3">
            <div className="text-sm font-bold text-neutral mb-2">
                Recent Searches
            </div>
            <div className="flex flex-wrap gap-2">
                {items.map((term) => (
                    <button
                        key={term}
                        type="button"
                        onClick={() => onSelect(term)}
                        className="badge badge-lg bg-primary/10 border-primary/10 text-neutral font-medium hover:bg-primary/20"
                    >
                        {term}
                    </button>
                ))}
            </div>
        </div>
    );
};
